import React, { useState, useEffect, useRef } from "react";
import { Col, Row } from "reactstrap";
import {
  message,
  Input,
  Button,
  Form,
  Space,
  Tooltip,
  Drawer,
  Card,
  Typography,
} from "antd";
import { EditOutlined } from "@ant-design/icons";
import moment from "moment";
import {
  updateMessage,
  getAllMessage,
  getAllRule,
  updateRule,
} from "../../helpers/helper";
import DataTable from "../../Components/Common/DataTable";
import Editor from "../../common/Editor";
import { useTranslation } from "react-i18next";
const Rules = () => {
  const { t } = useTranslation();
  document.title = t("rulesManager");

  const [form] = Form.useForm();
  const [formSearch] = Form.useForm();
  const [listRule, setListRule] = useState([]);
  const [visibleForm, setVisibleForm] = useState(false);
  const [drawerTitle, setDrawerTitle] = useState("");
  const nameRefId = useRef("common1");
  const [content, setContent] = useState(null);

  //pagination
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    try {
      const data = await getAllData();
      setListRule(data);
    } catch (error) {
      message.error(t("requiredPermission"));
    }
  }

  const getAllData = async (_prams) => {
    setLoading(true);
    try {
      const dataRes = await getAllRule();
      let data = convertDataTable(dataRes.data);
      setLoading(false);
      return data.length ? data : false;
    } catch (error) {
      setLoading(false);
      message.error(t("requiredPermission"));
    }
  };

  const convertDataTable = (dataArray) => {
    let data =
      dataArray.length > 0 &&
      dataArray.map((item) => {
        return {
          key: item._id,
          content: item.content.replace(/\n/g, "<br>"),
          createdTime: moment(new Date(item.createdTime)).format(
            "hh:mm DD/MM/YYYY"
          ),
        };
      });
    return dataArray ? data : [];
  };

  const columns = [
    {
      title: t("content"),
      dataIndex: "content",
      render: (_, record) => (
        <div
          style={{ maxWidth: "800px" }}
          dangerouslySetInnerHTML={{ __html: record.content }}
        ></div>
      ),
    },

    {
      title: t("createdTime"),
      dataIndex: "createdTime",
    },
    {
      title: t("action"),
      dataIndex: "",
      render: (_, record) => (
        <Space>
          <Tooltip title={t("edit")}>
            <Button
              type="primary"
              shape="circle"
              icon={<EditOutlined />}
              size="small"
              onClick={() => onEdit(record.key)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const onFinish = async (data) => {
    const dataReq = {
      content: content.trim(),
    };

    try {
      const dataRes = await updateRule(data.id, dataReq);
      if (dataRes.status === "success") {
        message.success(t("updateSuccess"));
      } else {
        message.error(t("updateFail"));
      }
      form.resetFields();
      fetchData();
      onClose();
    } catch (error) {
      if (error.response.status === 400) {
        return message.error(t("errorMess"));
      }
      message.error(t("permisstionDeniedAction"));
      formSearch.resetFields();
      form.resetFields();
      onClose();
    }
  };

  const onClose = () => {
    setContent("");
    form.resetFields();
    setVisibleForm(false);
  };

  const showDrawer = () => {
    setVisibleForm(true);
  };

  const handleNewBot = () => {
    setContent("");
    setDrawerTitle(t("createRule"));

    form.resetFields();
    showDrawer();
  };

  const onEdit = (key) => {
    const dataEdit = listRule.filter((item) => item.key === key);
    form.setFieldsValue({
      id: dataEdit[0].key,
    });
    setContent(`${dataEdit[0].content}` || "");
    setDrawerTitle(t("edit"));
    showDrawer();
  };

  return (
    <>
      <div className="page-content">
        <div>
          <Col>
            <Drawer
              title={drawerTitle}
              placement={"right"}
              width="50%"
              onClose={onClose}
              open={visibleForm}
              bodyStyle={{
                paddingBottom: 80,
              }}
              style={{ marginTop: "70px" }}
            >
              <Form
                form={form}
                layout="vertical"
                onFinish={onFinish}
                autoComplete="off"
              >
                <Row>
                  <Col hidden={true}>
                    <Form.Item name="id" label="Id">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Form.Item label={t("messenger")}>
                    <Editor
                      onChange={(v) => setContent(v)}
                      valueName={content}
                      refId={nameRefId}
                    />
                  </Form.Item>
                </Row>

                <Form.Item className="mt-3">
                  <Space>
                    <Button type="primary" htmlType="submit">
                      {t("save")}
                    </Button>

                    <Button type="danger" onClick={onClose}>
                      {t("close")}
                    </Button>
                  </Space>
                </Form.Item>
              </Form>
            </Drawer>
          </Col>
        </div>
        <DataTable
          listData={listRule}
          columns={columns}
          loading={loading}
          pageSize={1}
          pageSiz={1}
        />
      </div>
    </>
  );
};
export default Rules;
